import { render, staticRenderFns } from "./Multilab.vue?vue&type=template&id=0b6d009c&scoped=true&"
import script from "./Multilab.vue?vue&type=script&lang=js&"
export * from "./Multilab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d009c",
  null
  
)

export default component.exports